import _sfc_main from "./BuyBoxChangeShippingForm2.mjs";
/* empty css                           */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxChangeShippingForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0965f0c8"]]);
export {
  BuyBoxChangeShippingForm as default
};
//# sourceMappingURL=BuyBoxChangeShippingForm.mjs.map
